import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import Layout from "../../components/Common/Layout/layout";
import auth from "./auth";
import ComponentWrapper from "./ComponentWrapper.js";
import IdleTimerComponent from "../../components/IdleTimer/idleTimer"
import PropTypes from 'prop-types';

function ProtectedRouter({ component: Component, ...rest }) {
  const role = sessionStorage.getItem("roleId");
  const location = useLocation();
  return (
    <IdleTimerComponent >
      <Route
        {...rest}
        render={(props) => {
          const allProps = { ...rest, ...props };
          if (auth.isAuthenticated()) {
            if (role == 1 && location.pathname == '/dashboard') {
              return (
                props.history.goBack()
              )
            }
            if (role == 5 && location.pathname == '/dashboard') {
              return (
                props.history.goBack()
              )
            }
            if (location.pathname == '/auditHistory') {
              return (
                props.history.goBack()
              )
            }
            if (location.pathname == '/businessImpact') {
              return (
                props.history.goBack()
              )
            }
            if (location.pathname == '/risk') {
              return (
                props.history.goBack()
              )
            }
            if (location.pathname == '/analystRisks') {
              return (
                props.history.goBack()
              )
            }
            if (location.pathname == '/manager/risk_management') {
              return (
                props.history.goBack()
              )
            }
            if (location.pathname == '/riskManagement') {
              return (
                props.history.goBack()
              )
            }


            return (
              <Layout history={props.history}>
                <ComponentWrapper {...allProps}>
                  <Component {...props} />
                </ComponentWrapper>
              </Layout>
            );

          } else if (false) {
             return <Component {...props} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: "/login",
                }}
              />
            );
          }
        }}
      />
    </IdleTimerComponent>
  );
}
ProtectedRouter.propTypes = {
  component:PropTypes.any,
  history:PropTypes.any,
}


export default ProtectedRouter;
